import axios from 'axios'
import { BASE_URL_STRIPE } from '../actions'

export const getPriceBySku = async (sku: string) => {
  try {
    if (!sku) {
      throw new Error('Error on getPriceBySku - sku can not be empty')
    }
    const response = await axios.get(`${BASE_URL_STRIPE}/priceBySku`, {
      params: {
        sku
      }
    })
    return response?.data
  } catch (error) {
    console.error(`Error in getPriceBySku: ${error}`)
  }
}
